<template>
    <div class="warehouse_manage">
        <!-- 头部 -->
        <div class="warehouse_header">
            <div class="back_btn" @click="$router.back()">
                <van-icon name="arrow-left" size="24" />
            </div>
            <span class="header_title">仓库管理</span>
            <div class="placeholder"></div>
        </div>

        <!-- 功能菜单 -->
        <div class="menu_section" v-if="userInfo.stock_user_view_power == 0">
            <div class="section_title">库存查询</div>
            <div class="menu_grid">
                <div class="menu_item" @click="toProductList">
                    <div class="menu_icon" style="background: #E3F2FD;">
                        <van-icon name="shop-o" size="40" color="#2196F3" />
                    </div>
                    <span class="menu_name">产品查询</span>
                </div>
                <div class="menu_item" @click="toMaterialList">
                    <div class="menu_icon" style="background: #E8F5E9;">
                        <van-icon name="apps-o" size="40" color="#4CAF50" />
                    </div>
                    <span class="menu_name">物料查询</span>
                </div>

            </div>
        </div>

        <!-- 记录查询 -->
        <div class="menu_section">
            <div class="section_title">记录查询</div>
            <div class="menu_list">
                <div class="menu_list_item" @click="toStockRecord">
                    <div class="list_left">
                        <div class="list_icon" style="background: #F3E5F5;">
                            <van-icon name="records" size="36" color="#9C27B0" />
                        </div>
                        <div class="list_info">
                            <span class="list_name">出入库记录</span>
                        </div>
                    </div>
                    <van-icon name="arrow" size="20" color="#ccc" />
                </div>
                <div class="menu_list_item" @click="toShipmentRecord">
                    <div class="list_left">
                        <div class="list_icon" style="background: #FFEBEE;">
                            <van-icon name="logistics" size="36" color="#F44336" />
                        </div>
                        <div class="list_info">
                            <span class="list_name">发货记录</span>
                        </div>
                    </div>
                    <van-icon name="arrow" size="20" color="#ccc" />
                </div>
            </div>
        </div>

        <!-- 工具 -->
        <div class="menu_section" v-if="userInfo.stock_user_view_power == 0">
            <div class="section_title">工具</div>
            <div class="menu_list">
                <div class="menu_list_item" @click="toPrint">
                    <div class="list_left">
                        <div class="list_icon" style="background: #E8EAF6;">
                            <van-icon name="printer" size="36" color="#3F51B5" />
                        </div>
                        <div class="list_info">
                            <span class="list_name">标签打印</span>
                        </div>
                    </div>
                    <van-icon name="arrow" size="20" color="#ccc" />
                </div>
            </div>
        </div>

        <!-- 仓库作业归在底部菜单「工作台」下，高亮要跟着走，不然从工作台点进来
             底部亮的是「我的」，看着像跳错了页 -->
        <footer-main active="/internal/workbench"></footer-main>
    </div>
</template>

<script>
import footerMain from '@/components/footer.vue'

export default {
    name: 'WarehouseManage',
    components: {
        footerMain
    },
    data() {
        return {
            userInfo: {}
        }
    },
    mounted() {
        this.userInfo = this.$root.userInfo;
        document.title = "仓库管理"
    },
    methods: {
        // 产品列表
        toProductList() {
            this.$router.push('/warehouse/product')
        },

        // 物料列表
        toMaterialList() {
            this.$router.push('/warehouse/material')
        },

        // 出入库记录
        toStockRecord() {
            this.$router.push('/warehouse/record')
        },

        // 发货记录
        toShipmentRecord() {
            this.$router.push('/warehouse/shipment')
        },

        // 标签打印
        toPrint() {
            this.$router.push('/warehouse/print')
        }
    }
}
</script>

<style scoped>
.warehouse_manage {
    width: 100%;
    min-height: 100vh;
    background: #F6F6F6;
    padding-bottom: 140px;
}

.warehouse_header {
    width: 100%;
    height: 88px;
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 30px;
    box-sizing: border-box;
    box-shadow: 0 2px 8px rgba(0,0,0,0.05);
}

.back_btn i {
    font-size: 40px;
    color: #333;
}

.header_title {
    font-size: 32px;
    font-weight: bold;
    color: #333;
}

.placeholder {
    width: 40px;
}

.menu_section {
    padding: 20px 30px;
}

.section_title {
    font-size: 28px;
    color: #666;
    margin-bottom: 16px;
    padding-left: 8px;
}

.menu_grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 20px;
}

.menu_item {
    background: #fff;
    border-radius: 16px;
    padding: 30px 16px;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
}

.menu_icon {
    width: 80px;
    height: 80px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 16px;
}

.menu_icon .van-icon {
    font-size: 40px;
}

.menu_name {
    font-size: 28px;
    color: #333;
    font-weight: bold;
}

.menu_list {
    display: flex;
    flex-direction: column;
    gap: 16px;
}

.menu_list_item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 24px 30px;
    background: #fff;
    border-radius: 16px;
    box-shadow: 0 2px 12px rgba(0,0,0,0.06);
}

.list_left {
    display: flex;
    align-items: center;
}

.list_icon {
    width: 72px;
    height: 72px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 20px;
}

.list_icon .van-icon {
    font-size: 36px;
}

.list_info {
    display: flex;
    flex-direction: column;
}

.list_name {
    font-size: 30px;
    color: #333;
    font-weight: bold;
}

.menu_list_item > .van-icon {
    font-size: 20px;
}
</style>
